{
  "contactModal": {
    "delete": {
      "cancel": "İptal",
      "confirm": "Sil",
      "error": {
        "contactWithInformationRequests": "Atanmış bilgi talepleri olan kişi silinemez",
        "default": "Kişi silinirken hata oluştu",
        "title": "Kişi silinirken hata oluştu"
      },
      "message": "Bu kişiyi silmek istediğinizden emin misiniz?",
      "success": "Kişi başarıyla silindi",
      "title": "Kişiyi Sil"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Kişi Ekle"
    },
    "table": {
      "headers": {
        "actions": "İşlemler",
        "email": "E-posta",
        "id": "ID",
        "name": "Ad"
      }
    }
  },
  "onboarding": {
    "actions": {
      "activateAccount": "Hesabı etkinleştir",
      "back": "← Geri",
      "next": "İleri"
    },
    "ariaLabel": "Onboarding adımları",
    "gate": {
      "retryBanner": {
        "message": "Bir hata oluştu. Lütfen yeniden yükleyin ve tekrar deneyin.",
        "retry": "Tekrar deneyin"
      }
    },
    "placeholder": "Adım içeriği yakında.",
    "stepIndicator": "Adım {{current}} / {{total}}",
    "steps": {
      "my_facilities": {
        "name": "Tesisler",
        "subtitle": "Hangi üretim tesisleriyle çalıştığınızı ve ana şirketlerini bize bildirin.",
        "title": "Üretim tesislerinizi ekleyin"
      },
      "register_bp": {
        "name": "İş ortakları",
        "subtitle": "Ortak kuruluşlardaki kilit kişileri listeleyin — izlenebilirlik talepleri için ulaşmamız gereken alıcılar, acenteler veya alt yükleniciler.",
        "title": "İş ortaklarınızı ekleyin"
      },
      "review": {
        "name": "İnceleme",
        "subtitle": "Hesabınızı etkinleştirmeden önce her şeyin doğru olduğundan emin olun.",
        "title": "Bilgilerinizi inceleyin"
      },
      "verify_company": {
        "name": "Şirketi doğrula",
        "subtitle": "Devam etmeden önce doğru işletmeye sahip olduğumuzu onaylayın.",
        "title": "Şirket profilinizi doğrulayın"
      },
      "welcome": {
        "name": "Hoş geldiniz",
        "subtitle": "",
        "title": "Trace for Good'a hoş geldiniz"
      }
    },
    "verifyCompany": {
      "outcomes": {
        "answer_on_behalf": {
          "description": "For consultants, agents or partners filling in for the company shown above. Next, you'll register your company — responses stay attributed to you as their agent.",
          "label": "This is not my company, but I'm responding on their behalf"
        },
        "claim_company": {
          "description": "Confirm the profile above and continue setup as an employee of this company.",
          "label": "Yes, this is my company — I'd like to validate it"
        },
        "not_related": {
          "description": "Stops this verification. The person who invited you to Trace For Good will be notified so they can rectify the company shown above.",
          "label": "This isn't my company"
        }
      },
      "prompt": "Is this the profile of the company you are working at?",
      "summary": {
        "city": "City",
        "country": "Country",
        "street": "Street"
      }
    },
    "welcome": {
      "checkInfo": "Trace for Good hesabınıza erişmeden önce sizinle bazı bilgileri doğrulamak istiyoruz.",
      "intro": "Aramıza katıldığınız için memnun olduk. Bu portal, ürün izlenebilirliği ve uyumluluk bağlamında birden fazla tedarik zincirindeki iş ortakları arasında iş birliğini kolaylaştırmak için tasarlanmıştır.",
      "invitation": "Trace for Good platformuna, <strong>{{invitingCompanyName}}</strong> tarafından bir ürün izlenebilirliği sürecine katılmak üzere davet edildiniz. Bu süreç, tedarik zincirleri hakkında bilgi sağlamanızı gerektirebilir."
    }
  },
  "productionSiteModal": {
    "actions": {
      "addRegistrationId": "Kayıt kimliği ekle",
      "backToProductionSite": "Tesis formuna geri dön",
      "cancel": "İptal",
      "delete": "Sil",
      "removeRegistrationId": "Kayıt kimliği sil",
      "save": "Kaydet"
    },
    "createTitle": "Yeni üretim sitesi",
    "delete": {
      "cancel": "İptal",
      "confirm": "Sil",
      "message": "Bu üretim sitesini silmek istediğinizden emin misiniz?",
      "title": "Üretim Sitesini Sil"
    },
    "editTitle": "Üretim Sitesi Düzenle",
    "errors": {
      "cityRequired": "Şehir gereklidir",
      "coordinatesMaxDecimals": "Enlem ve boylam en fazla 6 ondalik basamaga sahip olabilir",
      "countryMustBeValid": "Ülke geçerli olmalıdır (örn. FR, DE)",
      "internalCodeTooLong": "Dahili kod en fazla 32 karakter olmalıdır",
      "nameRequired": "Ad gereklidir",
      "parentCompanyRequired": "Ana şirket gereklidir",
      "postalCodeTooShort": "Posta kodu en az 3 karakter olmalıdır",
      "streetRequired": "Caddesi gereklidir",
      "streetTooShort": "Caddesi en az 3 karakter olmalıdır"
    },
    "labels": {
      "city": "Şehir",
      "country": "Ülke",
      "internalCode": "Dahili kod",
      "latitude": "Enlem",
      "longitude": "Boylam",
      "name": "Üretim sitesi adı",
      "parentCompany": "Ana şirket",
      "performedActivities": "Yapılan faaliyetler",
      "postalCode": "Posta kodu",
      "registrationId": "Tesis kayıt kimlikleri",
      "street": "Sokak"
    },
    "parentCompanyChange": {
      "cancel": "Mevcut ana şirketi koru",
      "confirm": "Ana şirketi değiştir",
      "message": "Ana şirket, bu tesisin ait olduğu şirkettir. Değiştirmek bu tesisin sahipliğini güncelleyecek ve izlenebilirlik yönlendirmesini etkileyebilir.",
      "title": "Ana şirket değiştirilsin mi?"
    },
    "placeholders": {
      "city": "örn. İstanbul",
      "country": "Tesisin bulunduğu ülkeyi seçin",
      "internalCode": "örn. BD-DAK-001 veya dahili referansınız",
      "latitude": "örn. 41.0082",
      "longitude": "örn. 28.9784",
      "name": "örn. Dakka Kesim ve Dikiş Ünitesi A",
      "parentCompany": "örn. Trace for Good",
      "performedActivities": "örn. Kesim, dikiş, bitirme, boyama",
      "postalCode": "örn. 34000",
      "registrationId": "örn. KDV no, CIN, GSTIN, USC",
      "street": "örn. İstiklal Caddesi 10"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9 hane.",
      "EORI": "EORI: ülke kodu + 14 hane.",
      "GLN": "GLN: 13 hane.",
      "OTHER": "Diğer: en fazla 32 karakter.",
      "RCS": "RCS: RCS + boşluk + şirket adı + boşluk + [A,B] + boşluk + 9 hane.",
      "VAT": "VAT: ülke kodu (örn. FR) + 2 hane + 9 hane SIREN."
    },
    "registrationIdErrors": {
      "DUNS": "DUNS kayıt kimliği 9 haneli bir numara olmalıdır.",
      "EORI": "EORI kayıt kimliği şu formatta olmalıdır: ülke kodu (örn. FR) + 14 hane.",
      "GLN": "GLN kayıt kimliği 13 haneli bir numara olmalıdır.",
      "OTHER": "Diğer kayıt kimliği 32 karakterden az olmalıdır.",
      "RCS": "RCS kayıt kimliği şu formatta olmalıdır: RCS + boşluk + şirket adı + boşluk + [A,B] + boşluk + 9 hane.",
      "VAT": "VAT kayıt kimliği şu formatta olmalıdır: ülke kodu (örn. FR) + 2 haneli anahtar + 9 haneli SIREN numarası."
    },
    "tabs": {
      "generalInfo": "Genel bilgiler",
      "location": "Konum"
    },
    "tooltips": {
      "address": "Üretim sitesi adresi",
      "city": "Üretim sitesinin şehri",
      "country": "Üretim sitesinin ülkesi",
      "internalCode": "Üretim sitesinin dahili kodu",
      "latitude": "Üretim sitesinin enlemi",
      "longitude": "Üretim sitesinin boylamı",
      "name": "Üretim sitesi adı",
      "parentCompany": "Tesisi sahip olan şirket, kayıtlı iş ortakları listesinden seçilir.",
      "parentCompanyEdit": "Bu tesisin sahibi olan şirketi seçin.",
      "parentCompanyReadOnly": "Bu tesisi oluşturan veya sahip olan kuruluş ana şirketi değiştirebilir.",
      "performedActivities": "Üretim sitesinde yapılan faaliyetler",
      "postalCode": "Üretim sitesinin posta kodu",
      "registrationId": "Üretim sitesi kayıt kimlikleri",
      "street": "Üretim sitesinin sokağı"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Üretim Sitesi Ekle"
    },
    "create": {
      "error": "Üretim sitesi oluşturulurken hata oluştu",
      "successCreated": {
        "message": "Üretim sitesi başarıyla oluşturuldu",
        "title": "Üretim sitesi oluşturuldu"
      },
      "successMerged": {
        "message": "Bu ad ve adrese sahip bir uretim sitesi zaten deponuzda mevcut.",
        "title": "Mevcut uretim sitesi bulundu"
      }
    },
    "delete": {
      "error": "Üretim sitesi silinirken hata oluştu",
      "success": {
        "message": "Üretim sitesi başarıyla silindi",
        "title": "Üretim sitesi silindi"
      }
    },
    "filters": {
      "country": "Ülke",
      "internalCode": "Dahili kod",
      "isConfidential": "Gizli",
      "isConfidentialFalse": "Hayır",
      "isConfidentialTrue": "Evet",
      "name": "Üretim sitesi adı",
      "nothingFoundMessage": "Hiçbir sonuç bulunamadı",
      "performedActivities": "Yapılan faaliyetler",
      "searchPlaceholder": "Ara filtreler",
      "title": "Filtreler"
    },
    "search": {
      "placeholder": "Ad veya adrese göre ara"
    },
    "sorts": {
      "address": "Adres",
      "country": "Ülke",
      "email": "Email",
      "internalCode": "Dahili kod",
      "name": "Ad"
    },
    "table": {
      "headers": {
        "address": "Adres",
        "certificates": "Sertifikalar",
        "deleted": "Silindi",
        "id": "ID",
        "internalCode": "Dahili kod",
        "name": "Ad",
        "parentCompany": "Ana şirket",
        "performedActivities": "Yapılan faaliyetler",
        "registrationId": "Tesis kayıt kimlikleri"
      }
    },
    "title": "Üretim Siteleri",
    "update": {
      "error": "Üretim sitesi güncellenirken hata oluştu",
      "partialSave": {
        "message": "message"
      },
      "success": {
        "message": "Üretim sitesi başarıyla güncellendi",
        "title": "Üretim sitesi güncellendi"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Hata"
    }
  }
}
